const mutations = {
  recieveCurrencies (state, currencies) {
    state.currencies = currencies
  }
}

export default mutations
